
export enum enumDeploymentPlatformType {
  Development = 'Development', // a Development deployment environoment
  Production = 'Production', // a Production deployment environoment
}
